import React, { useContext } from 'react'
import { Link } from 'gatsby'

import StoreContext from '~/context/StoreContext'
import { Grid } from './styles'

import ProductGridItem from './ProductGridItem'

const ProductGrid = ({ products }) => {
  const {
    store: { checkout },
  } = useContext(StoreContext)

  const getPrice = price =>
    Intl.NumberFormat(undefined, {
      currency: checkout.currencyCode ? checkout.currencyCode : 'USD',
      minimumFractionDigits: 2,
      style: 'currency',
    }).format(parseFloat(price || 0))

  return (
    <Grid>
      {products ? (
        products.map((p, idx) => <ProductGridItem product={p} delay={10} multiplier={idx + 1} key={p.id} />)
      ) : (
        <p>No Products found!</p>
      )}
    </Grid>
  )
}

export default ProductGrid
